import appSettings from 'wanderu-config';
import {
    fetchPlaceDetailsAction,
    fetchPlaceFromTextAction,
} from 'wanderu-ducks-google';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

import { actions as bookingFormActions } from '../../appstate';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-app-booking:fetchLocationDetails');

function fetch(location, isDepart) {
    return async (dispatch, getState) => {
        const working = selectors.selectWorking(getState(), location);
        const success = selectors.selectSuccess(getState(), location);

        if (working || success) {
            return;
        }

        dispatch(actions.startWork(location));

        let error;
        let meta;

        try {
            const placeId = await dispatch(fetchPlaceFromTextAction.fetch({ input: location }));

            await dispatch(fetchPlaceDetailsAction.fetch(placeId));

            if (isDepart) {
                dispatch(bookingFormActions.setGoogleDepartId(placeId));
            }

            if (!isDepart) {
                dispatch(bookingFormActions.setGoogleDestinationId(placeId));
            }
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(location, meta, error));
        }
    };
}

function reset(opts) {
    return actions.reset(opts);
}

const fetchLocationDetailsAction = {
    fetch,
    reset,
    ...selectors,
};

export {
    fetchLocationDetailsAction,
};

export default {
    [namespace]: reducer,
};
